import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
  TUpdateCarLicensingForm,
  updateCarLicensing,
} from '@/modules/car/actions/async/updateCarLicensing';
import { getCarForm } from '@/modules/car/store/selectors';
import { AppDispatch } from '@/root-store';
import { LicensingAuthorityField, PHVField } from '@/shared/view/LicensingFields';

import { IRelatedInfoFieldsProps, IRelatedInfoHandle } from './config';
import { useRelatedInfoForm } from './useRelatedInfoForm';

const CarLicensingFields = React.forwardRef<IRelatedInfoHandle, IRelatedInfoFieldsProps>(
  (_, ref) => {
    const dispatch = useDispatch() as AppDispatch;

    const carForm = useSelector(getCarForm);

    const onSubmit = useCallback(
      (formValues: TUpdateCarLicensingForm) =>
        dispatch(updateCarLicensing({ carId: carForm.id, formValues })).unwrap(),
      [carForm.id, dispatch],
    );

    const { control } = useRelatedInfoForm<TUpdateCarLicensingForm>(ref, {
      defaultValues: {
        licensingAuthority: carForm.licensingAuthority,
        licenseNumber: carForm.licenseNumber,
      },
      onSubmit,
    });

    return (
      <>
        <LicensingAuthorityField control={control} />
        <PHVField control={control} />
      </>
    );
  },
);

CarLicensingFields.displayName = 'CarLicensingFields';

export { CarLicensingFields };
